module.exports = __webpack_public_path__ + "static/media/2.17_preview.e531ee7a.png";